<div v-show="isMenuExpanded" class="tt-o-menu__list" :class="alignClass" role="menu" tabindex="-1"
  @keydown.esc.stop="close()"
  @keydown.up.prevent="moveUp()"
  @keydown.down.prevent="moveDown()"
  @keydown.tab.stop="handleTab($event)">
  <div v-for="(item, index) in menuItems"
      class="tt-o-menu__item"
      :class="[{'tt-o-menu__item--active': index === selectedItemIndex}, menuItemTypeClass]"
      @click.prevent="menuItemSelected(index)"
      @keydown.enter.prevent="menuItemSelected(index)"
      @keydown.space.prevent="menuItemSelected(index)"
      tabindex="0"
      role="menuitem"
      :aria-controls="item.cntrlsId"
      :aria-expanded="item.expanded"
      :aria-disabled="item.disabled"
      :key="item.name">
      <tt-icon v-if="item.iconName" :name="item.iconName" size="md" class="tt-o-menu__icon"></tt-icon> <span class="tt-o-menu__item-title" v-html="item.title"></span>
  </div>
</div>
